export default "__VITE_ASSET__LKJcfb4b__"